import BadgeStar from './badges/BadgeStar';
import BadgeWheelchair from './badges/BadgeWheelchair';


export default {
  Star: BadgeStar,
  Wheelchair: BadgeWheelchair,
};
